module.exports = __webpack_public_path__ + "img/e-payment_02.01b457eb.svg";